// extracted by mini-css-extract-plugin
export default {"zoomModal":"K2-z","image":"L2-z","button":"M2-z","isOverlayShown":"N2-z"};